



















import {Component, Vue, Watch} from "vue-property-decorator";
import AuthService from "@/service/AuthService";
import Card from "@/components/Card/Card.vue";
import SocialNetwork from "@/components/Home/SocialNetwork.vue";
import Tags from "@/components/common/Tags/Tags.vue";
import Tag from "@/components/common/Tags/Tag.vue";
import AppConfig from "@/config/AppConfig";
import ConvertService from "@/service/ConvertService";
import AdminCpLayout from "@/layouts/AdminCpLayout.vue";

@Component({
    components: {AdminCpLayout, Tag, Tags, SocialNetwork, Card}
})
export default class Home extends Vue {
    public name: string = 'Home';

    private authService: AuthService = new AuthService();

    private user(): any {

        return this.authService.getUser();

    }

    mounted() {

    }

}
